// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadcrumbs_wrapper__T2wFc","list":"breadcrumbs_list__DOaBW","listItem":"breadcrumbs_listItem__BTGNz"};